import { service } from "@server/client";
import type {
  GetWalleyWidgetTokenQuery,
  GetWalleyWidgetTokenQueryVariables,
} from "@server/gql/graphql";
import { getWalleyWidgetTokenQuery } from "@server/queries/cart";

export const getWalleyWidgetToken = async (storeCode?: number) => {
  if (!storeCode) return undefined;
  try {
    const response = await service<
      GetWalleyWidgetTokenQuery,
      GetWalleyWidgetTokenQueryVariables
    >({
      query: getWalleyWidgetTokenQuery,
      variables: { storeCode },
    });

    return response.walleyWidgetToken;
  } catch (error: Error | unknown) {
    console.error("Error in getWalleyWidget", error);
    return undefined;
  }
};
